export default {
  // pullSuccessful.vue - 拉取成功弹窗
  pullSuccessful: {
    dialogTitle: "提示",
    tipText: "已拉取該地址最新的1萬條交易記錄",
    addressLabel: "地址：",
    transactionTimeRange: "交易時間範圍：",
    warningPulling: "全量數據拉取中，請耐心等待",
    cancelBtn: "取消",
    pullAllBtn: "拉全量",
    pullNotifyTitle: "提示",
    pullNotifyMessage:
      "數據拉取中，可能需要一些時間，請耐心等待，稍後再查看節點詳情",
  },

  // nodedetailTip.vue - 节点详情提示
  nodeDetailTip: {
    transactionData: "交易數據：",
    fullData: "全量數據",
    recentUpdate: "最近更新：",
    limitedData: "交易數據僅近期1萬條",
    syncAll: "同步全量",
    syncing: "同步中",
    syncFailed: "同步失敗",
    retry: "重試",
    tooltipContent:
      "數據拉取中，可能需要一些時間，請耐心等待，稍後再查看節點詳情",
    notifyTitle: "提示",
    notifyMessage:
      "數據拉取中，可能需要一些時間，請耐心等待，稍後再查看節點詳情",
  },

  // datasuccess.vue - 数据同步完成弹窗
  dataSuccess: {
    syncCompleteText: "歷史數據同步完成",
    addressLabel: "地址：",
    transactionTimeRange: "交易時間範圍：",
    warningTip: "先收起已擴展節點，重新展開以獲取最新交易數據",
    confirmBtn: "確認",
  },
};
